exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.maxShowcaseItems[data-v-7275c216] {\n  max-width: 500px;\n}\n.note[data-v-7275c216] {\n  font-weight: bold;\n  font-style: italic;\n  font-size: 11px;\n  line-height: 1.2;\n  color: rgba(0, 0, 0, 0.6);\n  height: 30px;\n}\n", ""]);

